import { render, staticRenderFns } from "./workplaces.vue?vue&type=template&id=893fcdfc&"
import script from "./workplaces.vue?vue&type=script&lang=js&"
export * from "./workplaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports